import React from 'react';
import { shapes } from 'react-data-grid';
import { isVAK } from '../../actions/root_url';

const { ExcelColumn } = shapes;

class FilterMultiKeyword extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  filterValues(row, columnFilter, columnKey) {
    if (columnFilter.filterTerm == null) {
      return true;
    }
    if (!isVAK) {
      let result = true;
      let value = '';
      // implement default filter logic
      if (row[columnKey] !== null) {
        value = row[columnKey].toLowerCase();
      }
      const rule = columnFilter.filterTerm;
      rule.map((r) => {
        if (r !== null) {
          result = result && value.includes(r.toLowerCase());
        }
      })
      return result;
    }
  }

  getRules(value) {
    const rules = value.split(' ');
    return rules;
  }

  handleChange(e) {
    let value = e.target.value;
    let filters = this.getRules(value);
    this.props.onChange({filterTerm: (filters.length > 0 ? filters : null), column: this.props.column, rawValue: value, filterValues: this.filterValues });
  }

  render() {
    let inputKey = 'filter-multi-keyword' + this.props.column.key;
    let columnStyle = {
      float: 'left',
      marginRight: 0,
      marginTop: '5px',
      maxWidth: '100%',
    };

    return (
      <div style={columnStyle}>
        <input key={inputKey} type="text" placeholder="Multi Keywords Search" className="form-control input-sm multiKeyword" onChange={this.handleChange} />
      </div>
    );
  }
}

FilterMultiKeyword.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  column: React.PropTypes.shape(ExcelColumn),
};

export default FilterMultiKeyword;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/filterMultiKeyword.jsx